import {
  PERMISSION_CANTILEVER_AGENTS_EVALUATIONS_CURATOR,
  PERMISSION_CANTILEVER_AGENTS_EVALUATIONS_DASHBOARD,
  PERMISSION_CANTILEVER_AGENTS_EVALUATIONS_EDITOR,
  PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_DASHBOARD,
  PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_LABELER,
  PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_REVIEWER,
  type RolodexPermissionsValues,
} from 'types'

export const METADATA_EVALUATIONS_PERMISSIONS: RolodexPermissionsValues[] = [
  PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_DASHBOARD,
  PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_REVIEWER,
  PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_LABELER,
]

/** Metrics view. The editor role includes this surface. */
export const AGENTIC_EVALUATIONS_DASHBOARD_PERMISSIONS: RolodexPermissionsValues[] =
  [
    PERMISSION_CANTILEVER_AGENTS_EVALUATIONS_DASHBOARD,
    PERMISSION_CANTILEVER_AGENTS_EVALUATIONS_EDITOR,
  ]

/** Create and delete runs, and read the cases list. */
export const AGENTIC_EVALUATIONS_EDITOR_PERMISSIONS: RolodexPermissionsValues[] =
  [PERMISSION_CANTILEVER_AGENTS_EVALUATIONS_EDITOR]

/** Validate & Curate and golden-case writes. */
export const AGENTIC_EVALUATIONS_CURATOR_PERMISSIONS: RolodexPermissionsValues[] =
  [PERMISSION_CANTILEVER_AGENTS_EVALUATIONS_CURATOR]

export const AGENTIC_EVALUATIONS_PERMISSIONS: RolodexPermissionsValues[] = [
  PERMISSION_CANTILEVER_AGENTS_EVALUATIONS_DASHBOARD,
  PERMISSION_CANTILEVER_AGENTS_EVALUATIONS_EDITOR,
  PERMISSION_CANTILEVER_AGENTS_EVALUATIONS_CURATOR,
]

export const EVALUATIONS_PERMISSIONS: RolodexPermissionsValues[] = [
  ...METADATA_EVALUATIONS_PERMISSIONS,
  ...AGENTIC_EVALUATIONS_PERMISSIONS,
]
